import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

/*

Props:

*/

const StyledDiv = styled.div`
    display: flex;
    flex: ${props => (props.flex) ? props.flex : 1};
    flex-flow: row ${props => (props.wrap) ? 'wrap' : 'nowrap'};
    align-items: ${props => (props.center) ? 'center' : 'start'};
    max-width: ${constants.layout.contentWidth.maxWidth}px;
    box-sizing: border-box;
    @media (max-width: ${props => (props.noBreakPoint) ? '0' : constants.layout.breakpoint.break1}px){
        align-items: ${props => (props.breakCenter || props.center) ? 'center' : 'start'};
    }
`;


const FlexRow = ({ style, children, ...rest }) => (
    <StyledDiv id="FlexRow" style = {style}  {...rest} >
        { children }
    </StyledDiv>
)

export default FlexRow;



// WEBPACK FOOTER //
// ./src/js/components/Primatives/FlexRow.jsx